import React from 'react';
import { Container, Row, Col, Button, CardImg } from 'reactstrap';
import './cyberDemand.css';

const CyberDemand = (props) => {
  return (
    <div className="py-5 my-5">
      <Container>
        <Row>
          <Col xs={{ size: 11 }} lg={{ size: 6 }}>
            <h1>Step Into The Demand</h1>
            <h3>Get ahead of the game by equipping your employees and teams with cybersecurity skills.</h3>
            <ul className="mt-4" style={{ listStyleType: 'square', color: '#FFBD00' }}>
              <li><p>Receive hands-on learning.</p></li>
              <li><p>Protect your company’s information.</p></li>
              <li><p>Enhance problem solving skills daily.</p></li>
              <li><p>Work with leading cybersecurity programs and companies.</p></li>
            </ul>
          </Col>
          <Col xs={{ size: 11 }} sm={{ size: 6 }}>
            <CardImg
              className="srf-images how-do-we-help-you-img"
              top
              width="100%"
              src="img/cyber-pie-chart-v2.png"
              alt="Card image cap"
            />
          </Col>
        </Row>
      </Container>
    </div >
  )
}

export default CyberDemand;
